<template>
    <div style="width:100%">
        <v-select style="font-size:13px;" v-model="tmpVal" :items="mngList" item-text="info" item-value="vals" label="Manage User" 
        class="align-self-center"  @change="updateMngInfo" outlined dense single-line hide-details>
        </v-select>
    </div>
</template>

<style scoped>
 a {text-decoration: none !important;}
</style>
 
<script>
export default {
  name: 'managerList',
  data () {
    return {
        mngList: [], tmpVal:"",
    }
  },
  created() {
        var requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ "usrID": localStorage.getItem("e3MngID")
                , "authCode": localStorage.getItem("e3MngCode")
            })
        };
        fetch('https://api.e3bss.com/_APP/POC/cfg_musr.php', requestOptions)
        .then((response) => {
            if(response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok');
        }).then((json) => {
            //console.log(json);
            if(json.result == "success") {
                this.mngList=[];
                this.mngList=json.value.list;
            }
        }).catch((error) => {
            console.log(error);
        });
  },
  //emits:['updateMngInfo'], 
  methods:{
    updateMngInfo() {
        //console.log("child-"+this.tmpVal)
        this.$emit("mngID", this.tmpVal);
    }
  },
}
</script>